/* unplugin-vue-components disabled */import { render } from "./App.vue?vue&type=template&id=4d07e111"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4d07e111&lang=scss"

import exportComponent from "E:\\Vue\\andon-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__